import {getUrlParameterFromString, removeParamFromString,} from "./utils/urlHelpers";
import {hasNumber} from "./utils/textHelpers";
import {initCarousels} from "./utils/carousel";
import {fetchDates, updateShowMoreDates} from "./utils/placeDates";
import {formatDate, getPrettyDatesRange, getReservationMaxDate} from "./utils/dateHelpers";
import {getCalendarTooltips, getLang, getLocale} from "./utils/localeUtils";
import {fetchSignificantDays, buildOnRenderDay} from "./utils/significantDays";
import {initNeedHelpButton, initNeedHelpWhatsappButton} from "./utils/needHelp";

const rightBottom = document.querySelector(".place-right-bottom");
const gallery = document.querySelector(".place-gallery");
const headerButtons = document.querySelectorAll(".btn-go-to-dates");
const woodBackground = document.querySelector(".has-wood-background");
const placeDatesSection = document.querySelector(".place-dates-section");

function positionElements() {
    //console.log("position elements");
    if (headerButtons) {
        let scrollY = window.scrollY || document.body.scrollTop || 0;
        let notification = document.querySelector(".place-notification");

        let highestHeight = 0;

        for(let i = 0; i < headerButtons.length; i++){
            const buttonDistance = headerButtons[i].getBoundingClientRect().bottom;

            if(buttonDistance != 0) { // is visible
                let height = buttonDistance + scrollY - appGetHeaderHeight() + 40

                if(height > highestHeight) {
                    highestHeight = height;
                }
            }
        }

        if (notification) {
            highestHeight -= 30;
        }

        woodBackground.style.backgroundSize = "100% " + highestHeight + "px";
    }

    if (rightBottom) {
        let height = gallery.offsetHeight;
        rightBottom.style.top = (height) + "px";
        rightBottom.classList.add("loaded");
    }

    //get lowest point of any of .place-content--food, .place-content--swimming, .place-content--price (there can be multiple, pick only the one with not display: none) bottom bounding client rect
    // get top position of .place-dates-section and if higher that that lowest point, add appropriate margin-top to .place-dates-section so we avoid overlapping with the elements above
    const foodContents = document.querySelectorAll(".place-content--food");
    const swimmingContents = document.querySelectorAll(".place-content--swimming");
    const priceContents = document.querySelectorAll(".place-content--price");
    let lowestFoodContent = null;
    let lowestSwimmingContent = null;
    let lowestPriceContent = null;
    let lowestContent = null;

    foodContents.forEach(content => {
        if (window.getComputedStyle(content).display !== 'none') {
            const rect = content.getBoundingClientRect();
            if (!lowestFoodContent || rect.bottom > lowestFoodContent) {
                lowestFoodContent = rect.bottom;
            }
        }
    });

    swimmingContents.forEach(content => {
        if (window.getComputedStyle(content).display !== 'none') {
            const rect = content.getBoundingClientRect();
            if (!lowestSwimmingContent || rect.bottom > lowestSwimmingContent) {
                lowestSwimmingContent = rect.bottom;
            }
        }
    });

    priceContents.forEach(content => {
        if (window.getComputedStyle(content).display !== 'none') {
            const rect = content.getBoundingClientRect();
            if (!lowestPriceContent || rect.bottom > lowestPriceContent) {
                lowestPriceContent = rect.bottom;
            }
        }
    });

    lowestContent = Math.max(
        lowestFoodContent || 0,
        lowestSwimmingContent || 0,
        lowestPriceContent || 0
    );

    if (placeDatesSection && lowestContent) {
        placeDatesSection.style.marginTop = 0;
        const datesRect = placeDatesSection.getBoundingClientRect();
        let marginTop = lowestContent - datesRect.top + 20;
        if (marginTop < 0) marginTop = 0;
        placeDatesSection.style.marginTop = marginTop + 'px';
    }
}

function appGetHeaderHeight() {
    let width = window.innerWidth
        || document.documentElement.clientWidth
        || document.body.clientWidth;

    if (width < 992) {
        return 50;
    }

    return 120;
}

function useFilterDates() {
    let goToDatesButtons = document.querySelectorAll("a.btn-go-to-dates");

    if (localStorage.getItem("filterDateFrom") && localStorage.getItem("filterDateTo")) {
        if (goToDatesButtons && goToDatesButtons.length > 0) {

            for(let i = 0; i < goToDatesButtons.length; i++){
                const button = goToDatesButtons[i];
                const newHref = button.getAttribute("data-reservation-url") + "&dateFrom=" + localStorage.getItem("filterDateFrom") + "&dateTo=" + localStorage.getItem("filterDateTo");

                button.setAttribute("href", newHref);
                button.innerText = button.getAttribute("data-reservation-label");
                button.classList.add("btn-reservation");
            }
        }

        const reservationButtons = document.querySelectorAll(".btn-reservation-own-date");
        for (let i = 0; i < reservationButtons.length; i++) {
            const button = reservationButtons[i];
            const newHref = button.getAttribute("href") + "&dateFrom=" + localStorage.getItem("filterDateFrom") + "&dateTo=" + localStorage.getItem("filterDateTo");
            button.setAttribute("href", newHref);
        }
    }

    if (goToDatesButtons) {
        for (let i = 0; i < goToDatesButtons.length; i++) {
            const button = goToDatesButtons[i];
            button.classList.remove("d-none");
        }
    }
}

useFilterDates();

function getNumberOfMonthsBasedOnResolution() {
    let width = window.innerWidth
        || document.documentElement.clientWidth
        || document.body.clientWidth;

    if (width < 768) {
        return 1;
    }

    if (width < 992) {
        return 2;
    }

    if (width < 1200) {
        return 3;
    }

    return 4;
}

var litepicker = null;

function useDatesCalendar() {
    const calendarInput = document.getElementById("calendar");
    if (!calendarInput) return;

    function adjustDateColors() {
        //not fetched yet
        if (!bookedDays) return;

        const months = document.querySelectorAll(".month-item");
        if (!months) return;

        for (let i = 0; i < months.length; i++) {
            const month = months[i];

            const firstDay = month.querySelector(".day-item:first-of-type");
            if (!firstDay) continue;

            const firstDayTime = parseInt(firstDay.dataset.time);
            const firstDayDate = new Date(firstDayTime);

            let prevDay = new Date(firstDayDate);
            prevDay.setDate(prevDay.getDate() - 1);
            prevDay.setHours(0, 0, 0, 0);


            bookedDays.forEach(function (item) {
                let dateWithoutTime = new Date(item);
                dateWithoutTime.setHours(0, 0, 0, 0);

                if (dateWithoutTime.getTime() === prevDay.getTime()) {
                    month.classList.add("starts-with-checkout-date")
                }
            });
        }
    }

    const placeDataEl = document.getElementById("place-data");
    const placeId = placeDataEl ? placeDataEl.dataset.id : null;
    const minDaysValue = placeDataEl ? parseInt(placeDataEl.getAttribute('data-min-days')) : 0;
    const minDays = minDaysValue > 0 ? minDaysValue : 2;
    const numberOfMonths = getNumberOfMonthsBasedOnResolution();

    const locale = getLocale();

    var significantDaysMap = {};

    litepicker = new Litepicker({
        element: calendarInput,
        inlineMode: true,
        singleMode: false,
        numberOfMonths: numberOfMonths,
        numberOfColumns: numberOfMonths,
        minDays: minDays,
        hotelMode: true,
        minDate: new Date(),
        maxDate: getReservationMaxDate(),
        allowRepick: false,
        locale: locale,
        format: "D. M. YYYY",
        tooltipNights: true,
        autoRefresh: true,
        lang: getLang(locale),
        tooltipText: getCalendarTooltips(locale),
        buttonText: {
            prev: '<i class="fas fa-angle-left"></i>',
            next: '<i class="fas fa-angle-right"></i>',
            close: '×',
            reset: 'Reset',
            apply: 'Apply'
        },
        onRenderDay: buildOnRenderDay(significantDaysMap),
        onRender: function () {
            adjustDateColors();
        },
        onDayHover: function (date, el) {
            if (!date || !el) return;
            if (typeof el !== 'object') return;

            if (el.indexOf("is-booked") > -1) return;
            if (el.indexOf("is-highlighted") === -1) return;

            let dateObject = new Date(date);
            dateObject.setHours(0, 0, 0, 0);

            const matchingTooltip = highlightedDaysTooltips.find(function (item) {
                let dateWithoutTime = new Date(item.date);
                dateWithoutTime.setHours(0, 0, 0, 0);

                return dateWithoutTime.getTime() === dateObject.getTime();
            });

            if (matchingTooltip) {
                const thisLink = document.querySelector(".day-item[data-time='" + date.getTime() + "']");
                if (thisLink) {
                    thisLink.title = matchingTooltip.tooltip;
                }
            }
        },
        onSelect: function (date1, date2) {
            //let thisPicker = this;
            //hideReserveButton();

            const dateFrom = formatDate(date1, "-");
            const dateTo = formatDate(date2, "-");

            if (dateFrom && dateTo) {
                showReserveButton(dateFrom, dateTo);
            }
        }
    });

    fetchSignificantDays().then(function (r) {
        Object.assign(significantDaysMap, r);
        litepicker.render();
    });

    var lockDays = [];
    var seasonDisabledDays = [];

    let seasonDisabledDates = $.ajax({
        url: "/api/season/disabled-dates?placeId=" + placeId,
        method: "GET",
        success: function (r) {
            r.forEach(function (item) {
                lockDays.push(new Date(item));
                seasonDisabledDays.push(new Date(item));
            });
        }
    });

    var bookedDays = [];

    function getReservedFutureDates() {
        const apartment = getApartment();

        return $.ajax({
            url: "/api/place/" + placeId + "/reserved-future-dates?apartment=" + apartment,
            method: "GET",
            success: function (r) {
                r.forEach(function (item) {
                    const isSingleDay = item.endsWith("-single-day");
                    const itemValue = isSingleDay ? item.replace("-single-day", "") : item;

                    const thisBookedDay = new Date(itemValue);
                    bookedDays.push(thisBookedDay);

                    // we returned fully booked days but we need to include previous day to make it look like half booked
                    // except when it's a single night reservation
                    if (!isSingleDay) {
                        lockDays.push(thisBookedDay);

                        let prevDay = new Date(itemValue);
                        prevDay.setDate(prevDay.getDate() - 1);

                        bookedDays.push(prevDay);
                    }
                });

                // if there is just 1 day between 2 reservations, we need to add that day to disabledDates also
                // do this once lockDays are filled
                r.forEach(function (item) {
                    let prevToPrevDay = new Date(item);
                    prevToPrevDay.setDate(prevToPrevDay.getDate() - 2);

                    if (lockDays.some(d => formatDate(d) === formatDate(prevToPrevDay)) &&
                        bookedDays.some(d => formatDate(d) === formatDate(prevToPrevDay))) {

                        let prevDay = new Date(item);
                        prevDay.setDate(prevDay.getDate() - 1);

                        if (!lockDays.some(d => formatDate(d) === formatDate(prevDay))) {
                            console.log("Adding day between reservations", prevDay);
                            lockDays.push(prevDay);
                        }
                    }
                });
            }
        });
    }

    let reservedDates = getReservedFutureDates();

    var highlightedDays = [];
    var highlightedDaysTooltips = [];

    function getSpecialFuturePrices() {
        const apartment = getApartment();

        return $.ajax({
            url: "/api/place/" + placeId + "/special-future-prices?apartment=" + apartment,
            method: "GET",
            success: function (r) {
                Object.keys(r).forEach(function (item) {
                    const newDate = new Date(item);
                    if (lockDays.indexOf(newDate) > -1) return;

                    highlightedDays.push(new Date(item));
                    highlightedDaysTooltips.push({
                        date: new Date(item),
                        tooltip: r[item]
                    });
                });
            }
        });
    }

    let specialPriceDates = getSpecialFuturePrices();

    //filter by apartments
    $(".apartment-dropdown-item").click(function (e) {
        e.preventDefault();

        const label = $(this).text();

        $("#apartmentsDropdownLabel").html(label);

        $(".apartment-dropdown-item").removeClass("active");
        $(this).addClass("active");

        addApartmentToReserveButton();

        bookedDays = [];
        lockDays = seasonDisabledDays.slice();
        let newReservedFutureDates = getReservedFutureDates();

        highlightedDays = [];
        highlightedDaysTooltips = [];
        let newSpecialFuturePrices = getSpecialFuturePrices();

        $.when(newReservedFutureDates, newSpecialFuturePrices).then(setSpecialDays, setSpecialDays);
    });

    $.when(seasonDisabledDates, reservedDates, specialPriceDates).then(setSpecialDays, setSpecialDays, setSpecialDays);

    function setSpecialDays() {
        litepicker.setLockDays(lockDays);

        litepicker.setBookedDays(bookedDays);

        litepicker.setHighlightedDays(highlightedDays);

        adjustDateColors();
    }

    addApartmentToReserveButton();
}

function setNumberOfMonthsInCalendar() {
    if (typeof (litepicker) === 'undefined' || !litepicker) return;

    const numberOfMonths = getNumberOfMonthsBasedOnResolution();

    //console.log("setNumberOfMonthsInCalendar", numberOfMonths);

    const currentNumberOfMonths = litepicker.options.numberOfMonths;
    if (currentNumberOfMonths === numberOfMonths) return;

    litepicker.setOptions({
        numberOfMonths: numberOfMonths,
        numberOfColumns: numberOfMonths
    })
}

function getApartment() {
    const activeApartment = document.querySelector(".apartment-dropdown-item.active");
    if (!activeApartment) return '';
    return activeApartment.dataset.apartment;
}

function addApartmentToReserveButton() {
    const apartment = getApartment();

    const reserveButton = document.querySelector(".btn-reserve");
    if (!reserveButton) return;

    const url = new URL(reserveButton.href);

    const params = new URLSearchParams(url.search);
    if (apartment && apartment.length > 0) {
        params.set('apartment', apartment);
    } else {
        params.delete('apartment');
    }

    url.search = params.toString();
    reserveButton.href = url.toString();
}

function showReserveButton(dateFrom, dateTo) {
    const reserveButton = document.querySelector(".btn-reserve");
    if (!reserveButton) return;

    const url = new URL(reserveButton.href);

    //add dateFrom and dateTo to get parameters
    const params = new URLSearchParams(url.search);
    params.set('dateFrom', dateFrom);
    params.set('dateTo', dateTo);

    url.search = params.toString();
    reserveButton.href = url.toString();

    const datesDescription = document.querySelector(".btn-reserve small");
    datesDescription.innerHTML = getPrettyDatesRange(dateFrom, dateTo);

    reserveButton.classList.remove("d-none");

    const wrap = document.querySelector(".calendar-section")
    if (wrap) {
        wrap.style.paddingBottom = "0";
    }
}

function hideReserveButton() {
    const reserveButton = document.querySelector(".btn-reserve");
    if (!reserveButton) return;

    reserveButton.classList.add("d-none");

    const wrap = document.querySelector(".calendar-section")
    if (wrap) {
        wrap.style.paddingBottom = "1.5rem";
    }
}

useDatesCalendar();

$(document).on('click', 'a.btn-go-to-dates:not(.btn-reservation), a.prices-anchor-link, a.terms-anchor-link', function (event) {
    //if(!$(this).attr("href").startsWith("#pills")){ //skip pills – video tabs
    event.preventDefault();

    $('html, body').animate({
        scrollTop: $($.attr(this, 'href')).offset().top - 60
    }, 500);
    //}
});

function readMore() {
    const alreadyHasReadMore = document.querySelector(".btn-read-more");
    if (alreadyHasReadMore) return;

    //for now just for .place-content--swimming. Just 2 lines of text will be visible, and more show on click on dynamically created "More" button
    const swimmingContents = document.querySelectorAll(".place-content--swimming");
    let swimmingContent = null;

    //get that swimmingContent with data-read-more value
    for (let i = 0; i < swimmingContents.length; i++) {
        if (swimmingContents[i].dataset["readMore"]) {
            swimmingContent = swimmingContents[i];
            break;
        }
    }

    if (!swimmingContent) return;
    const swimmingContentText = swimmingContent.querySelector(".place-content-text");
    if (!swimmingContentText) return;

    const swimmingContentTextHeight = swimmingContentText.scrollHeight;
    const readLessTest = swimmingContent.dataset["readLess"];
    const readMoreText = swimmingContent.dataset["readMore"];

    if (swimmingContentTextHeight > 90) {
        swimmingContent.insertAdjacentHTML('beforeend', '<button class="btn btn-link btn-sm btn-read-more pl-0 d-md-none">' + readMoreText + '</button>');
    }

    const readMoreButton = document.querySelector(".btn-read-more");
    if (!readMoreButton) return;

    readMoreButton.addEventListener("click", function () {
        if (swimmingContent.classList.contains("show-all")) {
            swimmingContent.classList.remove("show-all");
            readMoreButton.innerText = readMoreText;
        } else {
            swimmingContent.classList.add("show-all");
            readMoreButton.innerText = readLessTest;
        }
        //loose focus after click
        readMoreButton.blur();
    });
}

readMore();

$(function () {
    positionElements();
    //initDatesAutoRefresh();

    $(window).on("load", function () {
        $(".place-right-bottom").removeClass("d-none");
        $(".pagination").removeClass("d-none");
        positionElements();
        setTimeout(positionElements, 500);

        lightboxCheck();

        saveVisitedPlace();

        if (localStorage.hasOwnProperty("visitedPlaces")) {
            let visitedPlaces = localStorage.getItem("visitedPlaces");
            let fetchPlaces = JSON.parse(visitedPlaces);
            let placeId = $("#place-data").data("id");

            const index = fetchPlaces.indexOf(placeId);
            if (index > -1) {
                fetchPlaces.splice(index, 1);
            }
            if (fetchPlaces.length > 0) {
                let placesWrap = $("#visited-places");

                $.ajax({
                    url: "/parts/place/visited/grid",
                    method: "GET",
                    data: {
                        "ids": fetchPlaces.join()
                    },
                    success: function (result) {
                        placesWrap.html(result);
                        initCarousels();
                    }
                })
            }
        }
    });

    localStorage.removeItem("placeDatesPreviousType")
    fetchDates();
    displayBackButton();

    //Disable right click on images
    $(document).on('contextmenu', 'img', function () {
        return false;
    });

    $(".copy-current-url").click(function (e) {
        e.preventDefault();
        copyToClipboard(window.location.href)

        const notification = $("#copied-to-clipboard");
        notification.addClass("active");

        setTimeout(function () {
            notification.removeClass("active");
        }, 4000)
    });

    initNeedHelpButton();
    initNeedHelpWhatsappButton();

    //filter place dates
    $("#place-dates-filter-btn").click(function () {
        const emptyMessage = $("#dates-empty-message")
        emptyMessage.hide();
        if ($(this).hasClass("show-all")) {
            let label = $(this).data("show-all");
            $(this).html(label);
            $(".table-dates .date-taken").hide();
            let freeCount = $(".table-dates tr:visible").length;
            if (freeCount === 0) {
                emptyMessage.show();
            }

            $(this).removeClass("show-all");

            //All months are shown now, so without next month button
            //let nextMonth = document.getElementById("next-month");
            //nextMonth.style.display = "block";
        } else {
            let label = $(this).data("show-free");
            $(this).html(label);
            $(".table-dates .date-item").show();
            $(this).addClass("show-all");
            $("#monthsDropdownLabel").html($("#month-dropdown-0").text());

            let nextMonth = document.getElementById("next-month");
            nextMonth.style.display = "none";
        }
    })

    //filter by month
    $(".month-dropdown-item").click(function (e) {
        e.preventDefault();

        let month = parseInt($(this).data("month"));
        let label = $(this).text();
        const nextMonth = $("#next-month");
        let nextMonthTarget = parseInt($(this).next().data("month"));
        if (Number.isNaN(nextMonthTarget)) {
            nextMonthTarget = 1;
        }

        if (month === 0) {
            $(".date-item").show();
            nextMonth.hide();
        } else {
            $(".date-item").hide();
            $(".date-item.month-" + month).show();

            nextMonth.show();

            //Next month link needs to correspond to striped design
            let even = $(".date-item:visible").length % 2 === 0;

            if (even) {
                nextMonth.removeClass("bg-neutral-100")
                nextMonth.addClass("bg-white")
            } else {
                nextMonth.removeClass("bg-white")
                nextMonth.addClass("bg-neutral-100")
            }

            //console.log("next month is " + nextMonthTarget)
            $("#next-month-link").data("target", nextMonthTarget)
        }

        updateShowMoreDates();


        $("#monthsDropdownLabel").html(label);
    })

    $(document).on("click", "#next-month-link", function () {
        const target = $(this).data("target");
        $("#month-dropdown-" + target).click();
    });

    //Media pagination
    $(document).on('click', '#pagination-next', function () {
        const pagination = $(".pagination")
        const page = parseInt(pagination.data("page"));

        const nextPage = page + 1;

        paginatePhotos(nextPage);
    });

    $(document).on('click', '#pagination-prev', function () {
        const page = parseInt($(".pagination").data("page"));
        const prevPage = page - 1;

        paginatePhotos(prevPage);
    });

    function paginatePhotos(targetPage) {
        const pagination = $(".pagination");
        const pages = parseInt(pagination.data("pages"));

        if (targetPage >= pages) {
            $("#pagination-next").addClass("d-none");
        } else {
            $("#pagination-next").removeClass("d-none");
        }

        if (targetPage <= 1) {
            $("#pagination-prev").addClass("d-none");
        } else {
            $("#pagination-prev").removeClass("d-none");
        }

        $(".gallery-thumbnail-link").addClass("d-none");

        let thumbnailLinks = document.querySelectorAll(".gallery-thumbnail-link[data-page='" + targetPage + "']");

        for (let i = 0; i < thumbnailLinks.length; i++) {
            let thumbnailLink = thumbnailLinks[i];
            let thumbnail = thumbnailLink.querySelector(".gallery-thumbnail");

            thumbnail.src = thumbnail.dataset.src;
            thumbnailLink.classList.remove("d-none");
        }

        $("#place-thumbs-pagination-label").html(targetPage);

        pagination.data("page", targetPage);
    }
});

var resizeId;
window.addEventListener('resize', function () {
    clearTimeout(resizeId);
    resizeId = setTimeout(doneResizing, 200);
});

function doneResizing() {
    positionElements();
    fetchDates();
    setNumberOfMonthsInCalendar();
    readMore();
}

function lightboxCheck() {
    if ($(window).width() < 768) {
        $('.carousel-image-wrap a').replaceWith(function () {
            return $('img', this);
        })
    }
}

function displayBackButton() {
    let width = window.innerWidth
        || document.documentElement.clientWidth
        || document.body.clientWidth;

    const link = $("#place-back-link");
    let referrer = document.referrer;
    referrer = referrer.split("#")[0];

    if (referrer && referrer !== window.location.href) {
        let location = getUrlParameterFromString(referrer, "location");

        // Remove just place number to avoid infinite redirect
        if (location.length > 0 && location.length < 5 && hasNumber(location)) { //primitive check for place number format
            referrer = removeParamFromString(referrer, "location");
        }

        link.attr("href", referrer);
    } else {
        //console.log("back button history");
        link.click(function () {
            history.go(-1);
        })
    }

    if (width >= 992) {
        link.find(".back-link-label").removeClass("d-none");
    }
}

function saveVisitedPlace() {
    let placesString = localStorage.getItem("visitedPlaces");
    let places;

    if (localStorage.hasOwnProperty("visitedPlaces")) {
        places = JSON.parse(placesString);

        if (places.length > 4) {
            places.shift();
        }
    } else {
        places = []
    }

    let id = $("#place-data").data("id");

    if (places.indexOf(id) === -1) {
        places.push(id);

        localStorage.setItem("visitedPlaces", JSON.stringify(places));
    }
}

const copyToClipboard = str => {
    const el = document.createElement('textarea');
    el.value = str;
    el.setAttribute('readonly', '');
    el.style.position = 'absolute';
    el.style.left = '-9999px';
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);
};